import React, { useContext, useState } from 'react';

import styled from '@emotion/styled';

import { colors } from '../../../global';
import { useFormFields, useProfileData } from '../../../hooks';
import { ApiContext } from '../../../providers';
import { parseHTML } from '../../../services/parseHTML';
import { Button } from '../../Button';
import { Fields } from '../../Fields';
import { Loader } from '../../Loader';
import { OfferContext } from '../context';

export const OfferForm: React.FC = () => {
    const {
        contact_form_enabled,
        contact_form_submitted_message,
        contactFormButtonLabel,
        contactFormFields,
        slug,
    } = useContext(OfferContext);
    const { Upscore } = useContext(ApiContext);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const { profileData } = useProfileData();

    const [fieldValues, setFieldValues] = useFormFields(
        contactFormFields,
        profileData,
    );

    const handleSubmit = (event: any) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const postBody = {} as any;
        formData.append('partner', slug);

        // The data sent through UpscoreAPI is later on used as a `new FormData`
        // thats why we needed ad additional const `postBody` here.
        formData.forEach((value, key) => {
            postBody[key] = value;
        });

        Upscore.postUserOffer(postBody)
            .then(() => {
                setIsSubmitted(true);
            })
            .catch((error: any) => {
                console.error(error);
            });
    };

    if (!contact_form_enabled) return null;

    if (!profileData) return <Loader />;

    return isSubmitted && contact_form_submitted_message ? (
        <SubmittedMessage>
            {parseHTML(contact_form_submitted_message, 'markdown')}
        </SubmittedMessage>
    ) : (
        <Form className="Offer__form" onSubmit={handleSubmit}>
            <Fields
                inputType="inputField"
                fields={contactFormFields}
                setFieldValues={setFieldValues}
                fieldValues={fieldValues}
            />
            {contactFormButtonLabel && (
                <Button type="submit" variant="primary">
                    {contactFormButtonLabel}
                </Button>
            )}
        </Form>
    );
};

const Form = styled.form`
    input,
    textarea {
        width: 100%;
        border-radius: 30px;
        color: ${colors.black};
        background-color: ${colors.white};
        border: 1px solid ${colors.alto};
        padding: 15px 20px;
        margin: 0 0 15px;
        font-size: 20px;

        &:focus {
            outline: 0;
        }
    }

    textarea {
        min-height: 150px;
    }
`;

const SubmittedMessage = styled.div`
    border: 2px solid ${colors.screaminGreen};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    padding: 24px 40px;
    text-align: center;

    p {
        font-size: inherit;
        margin: 0;
    }
`;
